// =======================================
// TAG SELECTOR CONFIGURATION
// =======================================

/**
 * Tag option structure
 */
export interface TagOption {
  id: number;
  name: string;
}

/**
 * Props for the TagSelector component
 */
export interface TagSelectorProps {
  /** Currently selected tags */
  value: TagOption[];
  /** Callback when tags change */
  onChange: (tags: TagOption[]) => void;
  /** Placeholder text */
  placeholder?: string;
  /** Additional CSS class */
  className?: string;
  /** Whether the input is disabled */
  disabled?: boolean;
}

// Search configuration
export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_DEBOUNCE_DELAY = 300;
export const MAX_SEARCH_RESULTS = 20;

